import AnchorNavItem from "./anchor-nav-item";
export default AnchorNavItem;